<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    first_btn="Common.DeleteAll"
    :loading="loading"
    second_btn="Common.Cancel"
    :title="`${$t('Tenders.TenderProlongation')} #${tender.tenderNumber}   ${tender.tenderSubject || tender.title}`"
    @apply="submit"
    @close="cancel">
    <template #card-text>
      <div class="dialog-subtitle h6-text my-4">
        {{ $t('Tenders.ContinueTenderAfterRemovingExternalSuppliers') }}:
      </div>
      <div
        v-if="foreign_bidders"
        class="foreign_bidders width-80 pa-0 main__light_green">
        <div
          v-for=" bidder in foreign_bidders"
          :key="bidder.usreou"
          class="foreign_bidder d-flex px-0 py-2">
          <PersonTooltip
            :department="{name: bidder.organizationName}"
            :name=" bidder.fullName"
            with_photo/>
        </div>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>

<script>
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'
import ProlongTenderWithForeignOffers from 'components/tenders/dialogs/ProlongTenderWithForeignOffers.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'prolongTenderWithForeignOffers',
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  props: {
    tender: Object,
  },
  computed: {
    foreign_bidders() {
      return this.tender.bids.filter(bid => bid.foreignBidderBid).map(bid => bid.bidderInfo)
    }
  },
  methods: {
    cancel( ) {
      this.dialog =  false
    },
    async submit() {
      this.loading = true
      await  api.cancellForeignSupplierBids({tenderId: this.tender.tenderId})
        .then(res => {
          if ( res ) {
            // eslint-disable-next-line vue/no-mutating-props
            this.tender.bids = this.tender.bids.filter(bid => !bid.foreignBidderBid)
            this.cancel()
            this.$emit('openProlong')
          }
        })
      this.loading = false
    },
    open() {
      setTimeout(() => {
        this.dialog = true
      }, 200)
    }
  },
  components: {
    PersonTooltip,
    ProlongTenderWithForeignOffers
  }
}
</script>
